/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StructureProperty } from './structureProperty';
import { StructureInspectionGrade } from './structureInspectionGrade';


/**
 * partial building
 */
export interface Structure { 
    /**
     * internal Structure Key
     */
    id: number;
    /**
     * external Structure Key
     */
    externalid: string;
    /**
     * ID of the structure-group (the whole building)
     */
    structureGroupeId: number;
    /**
     * the number that belongs to the structure Name
     */
    structureType: number;
    /**
     * the kind of the partial building
     */
    structureName: string;
    /**
     * start date for a time depending Structure
     */
    startDate?: string;
    /**
     * end date for a time depending Structure
     */
    endDate?: string;
    /**
     * tenant key for access management
     */
    tenantId?: number;
    structureProperties?: Array<StructureProperty>;
    structureInspectionGrades?: Array<StructureInspectionGrade>;
}

